import { render, staticRenderFns } from "./ViewAdminUser.vue?vue&type=template&id=a9c51ff0&scoped=true"
import script from "./ViewAdminUser.vue?vue&type=script&lang=ts"
export * from "./ViewAdminUser.vue?vue&type=script&lang=ts"
import style0 from "./ViewAdminUser.vue?vue&type=style&index=0&id=a9c51ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c51ff0",
  null
  
)

export default component.exports